export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}

/**
 *
 * @param promise promise to guard with a timeout
 * @param ms time to wait for a promise in milliseconds
 * @param error A custom error to throw instead of generic one
 * @returns
 */
export const promiseTimeout = <T>(promise: Promise<T>, ms: number, error?: TimeoutError) => {
  const timeout = new Promise<never>((_, reject) =>
    setTimeout(() => reject(error ?? new TimeoutError(`Promise timed out after ${ms} milliseconds`)), ms),
  );

  return Promise.race([promise, timeout]);
};
